/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { Locale, LocaleKeys } from "../../model/locale";
import type { UnityDialogConfig } from "./unityDialog.types";

/**
 * Creates the standard no-network dialog configuration used by screen-level
 * connectivity overlays.
 *
 * @param dismissActionId Unique id for the Dismiss action.
 * @param retryActionId Unique id for the Retry action.
 * @param onDismiss Callback invoked when the dialog is dismissed.
 * @param onRetry Callback invoked when Retry is selected.
 * @returns Localized error dialog configuration with Dismiss and Retry actions.
 */
export const createNetworkErrorDialogConfig = (
  dismissActionId: string,
  retryActionId: string,
  onDismiss: () => void,
  onRetry: () => void
): UnityDialogConfig => ({
  title: Locale.getString(LocaleKeys.NETWORK_ERROR_TITLE),
  message: Locale.getString(LocaleKeys.NETWORK_ERROR_MESSAGE),
  variant: "error",
  actions: [
    {
      id: dismissActionId,
      label: Locale.getString(LocaleKeys.ACTION_DISMISS),
      onPress: onDismiss
    },
    {
      id: retryActionId,
      label: Locale.getString(LocaleKeys.NETWORK_ERROR_RETRY),
      onPress: onRetry
    }
  ],
  defaultFocusedActionId: dismissActionId
});
